import React from 'react';
import { RecomendacaoInteligencia, TipoRecomendacao } from '../models/inteligencia';
import { useMaestroContext } from '../context/MaestroContext';
import { LABEL_AREA, LABEL_PRODUTO } from '../utils/labels';
import EstadoVazio from './EstadoVazio';

const ICONE_RECOMENDACAO: Record<TipoRecomendacao, string> = {
  RISCO_ATRASO: 'bi bi-alarm', DEPENDENCIA_PENDENTE: 'bi bi-hourglass-split', ENTREGA_FALTANTE: 'bi bi-box-seam',
  ENTREGA_REJEITADA: 'bi bi-x-octagon', AGUARDANDO_DEPENDENCIA: 'bi bi-hourglass-split', POSSIBILIDADE_ANTECIPACAO: 'bi bi-rocket-takeoff',
  SOBRECARGA: 'bi bi-person-fill-exclamation', APROVACAO_PENDENTE: 'bi bi-check2-square', EVIDENCIA_AUSENTE: 'bi bi-file-earmark-excel',
  FALTA_ATUALIZACAO: 'bi bi-clock-history', CONFLITO_CALENDARIO: 'bi bi-calendar-x', PROBLEMA_RECORRENTE: 'bi bi-arrow-repeat',
  AREA_PRECISA_PDCA: 'bi bi-clipboard-pulse', OPORTUNIDADE_RECONHECIMENTO: 'bi bi-award', ALERTA_PRODUTO: 'bi bi-exclamation-diamond',
  RISCO_CONTABIL: 'bi bi-journal-x', RISCO_FISCAL: 'bi bi-receipt', RISCO_FINANCEIRO: 'bi bi-cash-coin',
};

interface PainelInteligenciaProps {
  recomendacoes: RecomendacaoInteligencia[];
  limite?: number;
  onAbrirAtividade?: (id: number) => void;
}

const PainelInteligencia: React.FC<PainelInteligenciaProps> = ({ recomendacoes, limite, onAbrirAtividade }) => {
  const { getArea, getUsuario } = useMaestroContext();
  const lista = limite ? recomendacoes.slice(0, limite) : recomendacoes;

  if (lista.length === 0) {
    return <EstadoVazio icone='bi bi-stars' titulo='Nenhuma recomendação no momento' descricao='A Inteligência do Maestro está monitorando o ciclo — novas recomendações aparecem aqui.' />;
  }

  return (
    <div className='mc-inteligencia'>
      {lista.map(rec => {
        const area = rec.areaId ? getArea(rec.areaId) : undefined;
        const responsavel = rec.responsavelId ? getUsuario(rec.responsavelId) : undefined;
        return (
          <div className='mc-inteligencia__item' key={rec.id}>
            <span className='mc-inteligencia__icone'><i className={ICONE_RECOMENDACAO[rec.tipo]} /></span>
            <div className='mc-inteligencia__corpo'>
              <strong>{rec.titulo}</strong>
              <p>{rec.motivo}</p>
              <div className='mc-inteligencia__meta'>
                {area && <span><i className='bi bi-diagram-3' /> {LABEL_AREA[area.tipo]}</span>}
                {responsavel && <span><i className='bi bi-person' /> {responsavel.nome}</span>}
                {rec.prazo && <span><i className='bi bi-calendar-event' /> {rec.prazo}</span>}
                {rec.produtoOrigem && <span><i className='bi bi-box' /> {LABEL_PRODUTO[rec.produtoOrigem]}</span>}
              </div>
              <p className='mc-inteligencia__impacto'><strong>Impacto:</strong> {rec.impacto}</p>
              {onAbrirAtividade && rec.atividadeIds[0] && (
                <div className='mc-inteligencia__acoes'>
                  <button type='button' className='mc-btn mc-btn--secondary mc-btn--sm' onClick={() => onAbrirAtividade(rec.atividadeIds[0])}>
                    Ver atividade
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PainelInteligencia;
